import React, { useEffect, useState } from "react";

import "../../components/extrato/Style.css";

import { ToastContainer, toast } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";
import { entryTypes } from "../../services/enums";
import ExtratoRow from "./extrato-row/ExtratoRow";
import {
  getEntryDetails,
  getEntryDetailsFiducia,
  listEntrys,
} from "../../services/entrys.service";
import { MdKeyboardArrowRight } from "react-icons/md";
import moment from "moment";
import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useEntrys } from "../../hooks/useEntrys";
import { Fragment } from "react";
import DescExtrato from "./desc-extrato/DescExtrato";
import { PageHeader } from "../page-header";

export default function () {
  const [formatedEntries, setFormatedEntries] = useState(null);
  const [descExtrato, setDescExtrato] = useState();
  const [entryMessage, setEntryMessage] = useState("");
  const [filterOptions, setFilterOptions] = useState({
    type: "",
    initialDate: "",
    finalDate: "",
  });
  const [showDetails, setShowDetails] = useState(false);

  const { account } = useAuth();
  const { entries, entriesLoader, fetchEntries } = useEntrys();

  moment.updateLocale("pt-br", {
    months: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julio",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    weekdays: [
      "Domingo",
      "Segunda Feira",
      "Terça Feira",
      "Quarta Feira",
      "Quinta Feira",
      "Sexta Feira",
      "Sábado",
    ],
  });

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    margin-top: 3em;
  `;

  async function onMountedEntrys() {
    const extratos = entries;

    const transacoesAgrupadas = {};

    extratos.forEach((transacao) => {
      const mes = moment(transacao.date).format("YYYY-MM");
      const dia = moment(transacao.date).format("YYYY-MM-DD");

      if (!transacoesAgrupadas[mes]) {
        transacoesAgrupadas[mes] = {};
      }

      if (!transacoesAgrupadas[mes][dia]) {
        transacoesAgrupadas[mes][dia] = [];
      }

      transacoesAgrupadas[mes][dia].push(transacao);
    });

    console.log(transacoesAgrupadas);

    setFormatedEntries(transacoesAgrupadas);
  }

  async function getEntry() {
    if (localStorage.getItem("taxNumber") === "12345678900") {
      setEntries({
        "2023-10": {
          "2023-10-10": [
            {
              id: 7332,
              identifier: 4342316779,
              transactionId: 61951048,
              description:
                "Transferência via Pix CELCOIN PAGAMENTOS S.A. - 1 10054019-4",
              type: "PreDebitPixOut",
              subType: "PreDebitPixOut",
              value: "-1.00",
              date: "2023-10-10 20:37:28",
              receiptUrl:
                "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2023-10-10/njmadkki.pdf",
              accountId: 321,
              documentNumber: "61951048",
            },
            {
              id: 7303,
              identifier: 4337804124,
              transactionId: 61766315,
              description:
                "Transferência via Pix Nu Pagamentos S.A - 1 20541545-1",
              type: "PreDebitPixOut",
              subType: "PreDebitPixOut",
              value: "-0.01",
              date: "2023-10-10 11:31:33",
              receiptUrl:
                "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2023-10-10/rofucssp.pdf",
              accountId: 321,
              documentNumber: "61766315",
            },
          ],
          "2023-10-09": [
            {
              id: 7287,
              identifier: 4332714407,
              transactionId: 61550281,
              description: "Transferência via Pix BANCO XP S.A. - 1 1131548-3",
              type: "PreDebitPixOut",
              subType: "PreDebitPixOut",
              value: "-1.00",
              date: "2023-10-09 19:09:25",
              receiptUrl:
                "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2023-10-09/ubqk40ob.pdf",
              accountId: 321,
              documentNumber: "61550281",
            },
          ],

          "2023-10-05": [
            {
              id: 7166,
              identifier: 4295391783,
              transactionId: 59981308,
              description:
                "Transferência via Pix Nu Pagamentos S.A - 1 20541545-1",
              type: "PreDebitPixOut",
              subType: "PreDebitPixOut",
              value: "-0.01",
              date: "2023-10-05 13:25:56",
              receiptUrl:
                "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2023-10-05/f3300azl.pdf",
              accountId: 321,
              documentNumber: "59981308",
            },
          ],
        },
        "2023-09": {
          "2023-09-29": [
            {
              id: 7101,
              identifier: 4249427909,
              transactionId: 57951718,
              description:
                "Transferência via Pix Nu Pagamentos S.A - 1 20541545-1",
              type: "PreDebitPixOut",
              subType: "PreDebitPixOut",
              value: "-0.01",
              date: "2023-09-29 15:26:31",
              receiptUrl:
                "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2023-09-29/a53uhi3h.pdf",
              accountId: 321,
              documentNumber: "57951718",
            },
            {
              id: 7100,
              identifier: 4249341063,
              transactionId: 57948657,
              description:
                "Transferência via Pix Nu Pagamentos S.A - 1 20541545-1",
              type: "PreDebitPixOut",
              subType: "PreDebitPixOut",
              value: "-0.01",
              date: "2023-09-29 15:15:54",
              receiptUrl:
                "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2023-09-29/vgvn1ag4.pdf",
              accountId: 321,
              documentNumber: "57948657",
            },
            {
              id: 7099,
              identifier: 4249210697,
              transactionId: 57943655,
              description:
                "Transferência via Pix Nu Pagamentos S.A - 1 20541545-1",
              type: "PreDebitPixOut",
              subType: "PreDebitPixOut",
              value: "-0.02",
              date: "2023-09-29 15:00:22",
              receiptUrl:
                "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2023-09-29/2j3in4gf.pdf",
              accountId: 321,
              documentNumber: "57943655",
            },
          ],
          "2023-09-28": [
            {
              id: 7096,
              identifier: 4242768537,
              transactionId: 57685311,
              description:
                "Transferência via Pix Nu Pagamentos S.A - 1 20541545-1",
              type: "PreDebitPixOut",
              subType: "PreDebitPixOut",
              value: "-0.01",
              date: "2023-09-28 19:13:54",
              receiptUrl:
                "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2023-09-28/a5lgjn0w.pdf",
              accountId: 321,
              documentNumber: "57685311",
            },
          ],
        },
      });
      return;
    }
    setLoader(true);

    try {
      const extratos = entries;

      const transacoesAgrupadas = {};

      extratos.forEach((transacao) => {
        const mes = moment(transacao.date).format("YYYY-MM");
        const dia = moment(transacao.date).format("YYYY-MM-DD");

        if (!transacoesAgrupadas[mes]) {
          transacoesAgrupadas[mes] = {};
        }

        if (!transacoesAgrupadas[mes][dia]) {
          transacoesAgrupadas[mes][dia] = [];
        }

        transacoesAgrupadas[mes][dia].push(transacao);
      });

      if (extratos.length) {
        setFormatedEntries(transacoesAgrupadas);
      } else {
        setFormatedEntries();
        setEntryMessage("Não existem extratos para essa conta!");
      }
      setLoader(false);
    } catch (err) {
      console.log("err ", err);
      toast.error("Não foi possivel carregar os Extratos");
      setEntryMessage("Não foi possivel carregar os extratos para essa conta!");
      setLoader(false);
    }
  }

  const handleOnClick = async (item) => {
    setDescExtrato(item);
    setShowDetails(true);
  };

  const closeDetails = async () => {
    setDescExtrato();
    setShowDetails(false);
  };

  const handleFilterOptions = (e) => {
    let initialDate;
    let finalDate;

    if (e.target.id == "date") {
      if (e.target.value) {
        initialDate = moment()
          .subtract(e.target.value, "days")
          .format("YYYY-MM-DD HH:mm:ss");
        finalDate = moment().format("YYYY-MM-DD HH:mm:ss");
  
        setFilterOptions({
          ...filterOptions,
          initialDate,
          finalDate,
        });
      } else {
        setFilterOptions({
          ...filterOptions,
          initialDate: "",
          finalDate: "",
        });
      }
    }

    if (e.target.id == "type") {
      if (e.target.value) {
        setFilterOptions({
          ...filterOptions,
          type: e.target.value,
        });
      } else {
        setFilterOptions({
          ...filterOptions,
          type: "",
        });
      }
    }
  };

  const setFilter = async () => {
    const response = await listEntrys(filterOptions);

    const transacoesAgrupadas = {};

    response.data.forEach((transacao) => {
      const mes = moment(transacao.date).format("YYYY-MM");
      const dia = moment(transacao.date).format("YYYY-MM-DD");

      if (!transacoesAgrupadas[mes]) {
        transacoesAgrupadas[mes] = {};
      }

      if (!transacoesAgrupadas[mes][dia]) {
        transacoesAgrupadas[mes][dia] = [];
      }

      transacoesAgrupadas[mes][dia].push(transacao);
    });

    setFormatedEntries(transacoesAgrupadas);
  };

  async function handleQuery() {
    const { type, initialDate, finalDate } = filterOptions;

    await fetchEntries("", initialDate, finalDate, type).then(() => {
      onMountedEntrys();
    });
  }

  const pages = () => {
    let pagesArr;

    if (showDetails) {
      pagesArr = [
        { 
          name: 'Extrato', 
          link: '', 
          action: closeDetails
        },
        { name: 'Detalhes', link: '' }
      ]
    } else {
      pagesArr = [
        { name: 'Extrato', link: '' },
      ]
    }

    return pagesArr
  }

  useEffect(() => {
    fetchEntries();
  }, []);

  useEffect(() => {
    onMountedEntrys();
  }, [entries]);

  return (
    <div className="pagina-extrato">
      <div className="col-md-10 pagina-extrato-content">
        <div className="header">
          <div className="col-xl-12">
            <PageHeader title='Extrato' pages={pages()} />
          </div>
        </div>

        {!showDetails ? (
          <>
            <div className="filter-area">
              {/* <div className="col-md-3">
              <h2>Pesquisar</h2>
              <div className="filter-item">
                <HiOutlineSearch size={18} />
                <input placeholder="Pesquisar" />
              </div>
            </div> */}
              <div className="col-md-5">
                <h2>Período</h2>
                <div className="filter-item">
                  <select
                    defaultValue={"Selecione"}
                    id="date"
                    onChange={(e) => handleFilterOptions(e)}
                  >
                    <option value={""} className="filter-item-option">
                      Selecione
                    </option>
                    <option value={7} className="filter-item-option">
                      Últimos 7 dias
                    </option>
                    <option value={15} className="filter-item-option">
                      Últimos 15 dias
                    </option>
                    <option value={30} className="filter-item-option">
                      Últimos 30 dias
                    </option>
                    <option value={60} className="filter-item-option">
                      Últimos 60 dias
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-md-5">
                <h2>Tipo de Transação</h2>
                <div className="filter-item">
                  <select
                    defaultValue={"Selecione"}
                    id="type"
                    onChange={(e) => handleFilterOptions(e)}
                  >
                    <option
                      value={""}
                      className="filter-item-option"
                    >
                      Selecione
                    </option>
                    <option
                      value={"Pix recebido"}
                      className="filter-item-option"
                    >
                      Pix recebido
                    </option>
                    <option
                      value={"Pix enviado"}
                      className="filter-item-option"
                    >
                      Pix enviado
                    </option>
                    <option
                      value={"TED recebido"}
                      className="filter-item-option"
                    >
                      TED recebido
                    </option>
                    <option
                      value={"TED enviado"}
                      className="filter-item-option"
                    >
                      TED enviado
                    </option>
                    <option
                      value={"Pagamento de boleto"}
                      className="filter-item-option"
                    >
                      Pagamento de boleto
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <button onClick={handleQuery}>Buscar</button>
              </div>
            </div>

            <div className="lancamentos">
              <div className="row">
                <div className="scroll col-xl-12">
                  <div className="lancamento">
                    <div className=" row">
                      {formatedEntries && !entriesLoader && (
                        <>
                          {Object.keys(formatedEntries).map(
                            (element, index) => (
                              <Fragment key={index}>
                                <div className="lancamentos-mes col-md-12">
                                  <h2>
                                    {moment(
                                      Object.keys(formatedEntries[element])[0]
                                    ).format("MMMM[,] YYYY")}
                                  </h2>
                                </div>

                                {Object.keys(formatedEntries[element]).map(
                                  (item, index) => (
                                    <Fragment key={index}>
                                      <div className="lancamentos-dia col-md-12">
                                        <h2>
                                          {moment(
                                            formatedEntries[element][item][0]
                                              .date
                                          ).format("DD[,] dddd")}
                                        </h2>
                                        <h3>R$</h3>
                                      </div>
                                      {formatedEntries[element][item].map(
                                        (entry) => (
                                          <ExtratoRow
                                            key={entry.id}
                                            data={entry}
                                            handleClick={handleOnClick}
                                          />
                                        )
                                      )}
                                    </Fragment>
                                  )
                                )}
                              </Fragment>
                            )
                          )}
                        </>
                      )}
                      {entries.length < 1 && !entriesLoader && (
                        <div className="entryMessage">Sem resultados!</div>
                      )}
                      <div className="loader-div">
                        <BeatLoader
                          color={"var(--secondary-color)"}
                          loading={entriesLoader}
                          css={override}
                          size={20}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <DescExtrato data={descExtrato} closeDetails={closeDetails} />
        )}
        <ToastContainer limit={2} />
      </div>
    </div>
  );
}
